/** W82 Web-5h-N2b-2 (b-HW23, D-701): die gemeinsame Datumsform der Welt, wortgleich mit iOS `Datumsform` (5e-Bericht Abschnitt 8).
 *  Künftige kurze Daten ohne Endpunkt („22.10“, „Do 22.10“), vergangene behalten ihn („seit 14.10.“), erledigt und bezahlt
 *  tragen das Jahr („bezahlt 21.10.2026“). Eingabe ist immer der ISO-Tag „JJJJ-MM-TT“; gespeicherte Daten und API bleiben. */

export type Datumsform = "kurz" | "wochentagKurz" | "vergangen" | "mitJahr";

const WT = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

function wochentagNr(iso: string): number {
  // W82 Web-6b (WN-21): nur der Tag; ein Zeitpunkt („2026-10-22T14:30:00Z“) ergäbe sonst einen ungültigen Tag
  const [j, m, t] = iso.slice(0, 10).split("-").map(Number);
  return new Date(Date.UTC(j ?? 1970, (m ?? 1) - 1, t ?? 1)).getUTCDay();
}

/** Ein ISO-Tag in einer der vier Formen: kurz „22.10“, wochentagKurz „Do 22.10“, vergangen „14.10.“, mitJahr „21.10.2026“. */
export function datumText(iso: string, form: Datumsform): string {
  const tm = `${iso.slice(8, 10)}.${iso.slice(5, 7)}`;
  if (form === "kurz") return tm;
  if (form === "wochentagKurz") return `${WT[wochentagNr(iso)]} ${tm}`;
  if (form === "vergangen") return `${tm}.`;
  return `${tm}.${iso.slice(0, 4)}`;
}

/** Tag einer Frist ohne Betrag (iOS `fristTag`): ab heute wie künftig („22.10“), vorbei wie bisher („14.10.“). */
export function fristTag(iso: string, heute: string): string {
  return datumText(iso, iso.slice(0, 10) >= heute ? "kurz" : "vergangen");
}

/** Erledigt-Wort (iOS `erledigt(art:am:)`): „bezahlt 21.10.2026“ bei einer Zahlung, sonst „erledigt 21.10.2026“; `tag` ist der
 *  Berliner Ereignistag (saetze.ts `eingangsTag`), ohne gültigen Tag bleibt das Wort allein (Rückfall wie bisher). */
export function erledigtText(art: string, tag: string | null): string {
  const wort = art === "zahlen" ? "bezahlt" : "erledigt";
  return tag ? `${wort} ${datumText(tag, "mitJahr")}` : wort;
}
